import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

import { SharingInvitation } from '@/shared/api/protocol-ts/model/dto_sharing_pb';
import {
  LoadingStateType,
  DefaultInitialState,
  SliceName,
} from '@/shared/config';

export const sharingAdapter = createEntityAdapter<SharingInvitation>({
  selectId: (sharingInvitation) => sharingInvitation.ID,
});

type SharingSliceInitialState = DefaultInitialState;

const initialState: SharingSliceInitialState = {
  loading: 'idle',
};

const sharingState = sharingAdapter.getInitialState(initialState);

type SharingState = typeof sharingState;

const sharingSlice = createSlice({
  name: SliceName.sharing,
  initialState: sharingState,
  reducers: {
    addOne: (state, action: PayloadAction<SharingInvitation>) =>
      sharingAdapter.addOne(state as SharingState, action.payload),
    addMany: (state, action: PayloadAction<SharingInvitation[]>) =>
      sharingAdapter.addMany(state as SharingState, action.payload),
    removeOne: (state, action: PayloadAction<string>) =>
      sharingAdapter.removeOne(state as SharingState, action.payload),
    removeAll: (state) => sharingAdapter.removeAll(state as SharingState),
    setOne: (state, action: PayloadAction<SharingInvitation>) =>
      sharingAdapter.setOne(state as SharingState, action.payload),
    setMany: (state, action: PayloadAction<SharingInvitation[]>) =>
      sharingAdapter.setMany(state as SharingState, action.payload),
    setNewestOne: (state, action: PayloadAction<SharingInvitation>) => {
      const currentRevisionNumber =
        state.entities[action.payload.ID]?.Revision?.Number ?? 0;
      const payloadRevisionNumber = action.payload.Revision?.Number ?? 0;

      if (payloadRevisionNumber > currentRevisionNumber) {
        sharingAdapter.setOne(state as SharingState, action.payload);
      }
    },
    setLoading: (state, action: PayloadAction<LoadingStateType>) => {
      state.loading = action.payload;
    },
  },
});

export const { actions } = sharingSlice;

export default sharingSlice.reducer;
